<app-resource-table-base
    #tableBase
    *ngIf="user"
    [matSortActive]="matSortActive"
    [columnsData]="columnsData"
    [columnsKeys]="columnsKeys"
    [expandedRowId]="expandedRowId"
    [expandedFn]="expandedFn"
    (expansionToggled)="expansionToggled($event)"
    [otherContext]="otherContext"
    [expandingTable]="true"
    [canSelect]="isCompletedFilter"
    [filter]="filter"
    [tableFilterItems]="tableFilterItems"
    [pageSizeOptions]="pageSizeOptions"
>
    <ng-container tableFiltersTempl>
        <app-table-filter
            [filtersTogglesInOnBtn]="true"
            [defaultFilter]="GlobalFilterProperty.SEARCH"
            [inGlobalFilter]="true"
            color="accent"
            #filter
        >
            <app-table-search
                toggleBtnLabel="Schema"
                i18n-toggleBtnLabel
                [inGlobalFilter]="true"
                class="align-space"
                searchFilterRef
            ></app-table-search>
            <app-table-date-filter [inGlobalFilter]="true" color="accent" deadlineFilterRef></app-table-date-filter>
            <app-select-filter
                *ngIf="isActivityTab()"
                [inGlobalFilter]="true"
                class="filter-space"
                label="Status"
                i18n-label
                [property]="GlobalFilterProperty.RESOURCS_OCCASION"
                [options]="resourceStatusOptions"
                resStatusFilterRef
            ></app-select-filter>
            <app-select-filter
                [inGlobalFilter]="true"
                class="filter-space"
                label="Type"
                i18n-label="@@type"
                [property]="{
                    name: GlobalFilterProperty.SCOPE,
                    type: GlobalFilterPropertyType.RESOURCE_TYPE
                }"
                [options]="resourceTypeOptions"
                scopesFilterRef
            >
            </app-select-filter>
            <app-tag-chip-search-filter
                [inGlobalFilter]="true"
                fxFlex="50%"
                fxFlex.lt-md="100%"
                fxLayoutAlign="start"
                tagsFilterRef
            ></app-tag-chip-search-filter>
        </app-table-filter>
    </ng-container>
</app-resource-table-base>
<ng-template #multipleSelectionActionsTemplate let-selected>
    <button
        class="download-hover-tools-btn"
        mat-icon-button
        matTooltip="Download selected"
        i18n-matTooltip="@@downloadSelected"
        (click)="$event.stopPropagation(); downloadSelected(selected)"
    >
        <mat-icon>save_alt</mat-icon>
        <span i18n>Download</span>
    </button>
</ng-template>
<ng-template #expansionContextTemplate let-resource>
    <ng-container *ngIf="resource.occasionStatus == 'created'">
        <app-resource-history-listing *ngIf="expandedFn(resource)" [resource]="resource"></app-resource-history-listing>
    </ng-container>
    <ng-container *ngIf="resource.occasionStatus != 'created'">
        <app-general-test-results
            *ngIf="ResourceTypes.parentType(resource.type_id) === ResourceTypes.TEST && expandedFn(resource)"
            class="res-test-results overview"
            [user]="user"
            [isCourseItem]="false"
            [resource]="resource"
            [occasionId]="resource.opportunity_id"
        ></app-general-test-results>

        <app-course-player-results
            *ngIf="ResourceTypes.parentType(resource.type_id) === ResourceTypes.COURSE && expandedFn(resource)"
            [tabsIndex]="0"
            [user]="user"
            [occasionId]="resource.opportunity_id"
            [resource]="resource"
            (retakeCourse)="retake($event)"
        ></app-course-player-results>

        <app-material-items-display-info
            *ngIf="ResourceTypes.parentType(resource.type_id) === ResourceTypes.MATERIAL && expandedFn(resource)"
            class="user-occ-mat-info"
            [user]="user"
            [occasionId]="resource.opportunity_id"
            [resource]="resource"
        ></app-material-items-display-info>

        <!-- <app-activity-scorm-expansion-info
            *ngIf="ResourceTypes.parentType(resource.type_id) === ResourceTypes.SCORM && expandedFn(resource)"
            class="user-occ-mat-info"
            [user]="user"
            [occasionId]="resource.opportunity_id"
            [resource]="resource"
        ></app-activity-scorm-expansion-info> -->
        <app-resource-history-listing
            *ngIf="ResourceTypes.parentType(resource.type_id) === ResourceTypes.SCORM && expandedFn(resource)"
            [resource]="resource"
        ></app-resource-history-listing>
    </ng-container>
</ng-template>

<ng-template #img let-resource>
    <app-image-view
        [media_id]="resource.media$"
        [proportional]="true"
        [paddingBottom]="'58px'"
        [smallSpinner]="true"
        [showImgModalOnClick]="true"
    ></app-image-view>
</ng-template>
<ng-template #title let-resource>
    <ng-container *ngIf="!(isMobile$ | async)">
        <span> {{ resource.title }}</span>
        <div class="hover-wrapper">
            <button
                class="hover-tools-btn view"
                mat-icon-button
                matTooltip="View"
                (click)="$event.stopPropagation(); browse(resource)"
                i18n-matTooltip="@@view"
            >
                <mat-icon>visibility</mat-icon>
            </button>
            <button
                class="hover-tools-btn view"
                mat-icon-button
                [matTooltip]="getPlayBtnTxt(resource)"
                (click)="$event.stopPropagation(); !resource.loading && play(resource)"
            >
                <mat-icon>play_circle</mat-icon>
            </button>
            <ng-container *ngIf="customer$ | async; let customer">
                <button
                    *ngIf="canEdit(resource, customer)"
                    class="hover-tools-btn view"
                    mat-icon-button
                    matTooltip="Edit"
                    i18n-matTooltip
                    (click)="$event.stopPropagation(); !resource.loading && edit(resource)"
                >
                    <mat-icon class="material-icons-outlined">edit</mat-icon>
                </button>
            </ng-container>
            <ng-container *ngIf="resource.last_publish">
                <button
                    class="hover-tools-btn"
                    *ngIf="!(shareLoading | async); else shareLoadTemp"
                    mat-icon-button
                    matTooltip="Share"
                    i18n-matTooltip="@@share"
                    (click)="$event.stopPropagation(); shareService.openShareDialog(resource, shareLoading)"
                >
                    <mat-icon>share</mat-icon>
                </button>
            </ng-container>
            <button
                *ngIf="resource.downloads"
                class="hover-tools-btn"
                mat-icon-button
                matTooltip="Download PDF"
                i18n-matTooltip="@@downloadPDF"
                (click)="$event.stopPropagation(); download(resource)"
            >
                <mat-icon>save_alt</mat-icon>
            </button>
            <button
                *ngIf="resource.opportunity_id"
                class="hover-tools-btn"
                mat-icon-button
                matTooltip="Delete"
                (click)="$event.stopPropagation(); deleteCourseFromList(resource)"
                i18n-matTooltip="@@delete"
            >
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </ng-container>
    <ng-container *ngIf="isMobile$ | async">
        <div fxLayout="row" fxLayoutGap="5px" class="w-100" fxLayoutAlign="start start">
            <app-image-view
                [media_id]="resource.media$"
                [proportional]="true"
                [paddingBottom]="'50px'"
                [smallSpinner]="true"
            ></app-image-view>
            <span class="res-title" fxFlex="grow"> {{ resource.title }}</span>
            <div fxLayout="column" fxLayoutAlign="start start">
                <ng-container *ngIf="customer$ | async; let customer">
                    <mat-icon
                        *ngIf="resource | resourceStatus : true as resStatus"
                        (click)="$event.stopPropagation(); onEditCreated(resource, customer)"
                        [ngStyle]="{ color: resStatus.color }"
                    >
                        {{ resStatus.icon }}
                    </mat-icon>
                </ng-container>
                <!-- <mat-icon
                    [ngStyle]="{ color: (resource | resourceCertificate).color }"
                    [ngClass]="{ 'disabled-icon': !resource.downloads }"
                    class="cert-icon"
                >
                    {{ (resource | resourceCertificate).icon }}
                </mat-icon> -->
                <ng-container *ngIf="canExpand(resource)">
                    <button
                        *ngIf="resource.id as expandId"
                        class="mob-expand-btn"
                        (click)="$event.stopPropagation(); expansionToggled(resource)"
                        mat-icon-button
                    >
                        <mat-icon>{{ expandedFn(resource) ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                </ng-container>
            </div>
        </div>
    </ng-container>
</ng-template>
<ng-template #type let-resource>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@type">Type: </span>
    <div fxLayout="row" fxLayoutAlign="start center" class="type-wrap">
        <mat-icon
            *ngIf="ResourceTypes.isKDFontIcon(resource.type_id)"
            [fontSet]="resource.type_id | typeFontSet"
            [fontIcon]="resource.type_id | typeFontIcon"
            class="kd-icon"
        ></mat-icon>
        <mat-icon
            *ngIf="!ResourceTypes.isKDFontIcon(resource.type_id)"
            [ngClass]="resource.type_id | typeFontIcon"
            class="kd-icon"
            >{{ resource.type_id | typeFontIcon }}</mat-icon
        >
        {{ ResourceTypes.label(resource.type_id, { capitalize: true }) }}
    </div>
</ng-template>
<ng-template #registration let-resource>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@registration">Registration: </span>
    <div fxLayout="row" fxLayoutAlign="start center" class="type-wrap">
        <div
            [class.disabled-registration]="(resource | resourceRegistrationInfo).disabled"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="5px"
            class="registration-status-wrapper"
        >
            <div
                class="registration-status-circle"
                [style.border-color]="(resource | resourceRegistrationInfo).borderColor"
                [style.background-color]="(resource | resourceRegistrationInfo).backgroundColor"
                [style.cursor]="(resource | resourceRegistrationInfo).disabled ? 'not-allowed' : 'pointer'"
                (click)="$event.stopPropagation()"
            ></div>
            <div fxLayout="column" fxLayoutAlign="start center">
                <div class="registration-status-label-text">{{ (resource | resourceRegistrationInfo).label }}</div>
                <div *ngIf="(resource | resourceRegistrationInfo).details" class="registration-status-label-details">
                    {{ (resource | resourceRegistrationInfo).details }}
                </div>
            </div>
        </div>
        <div></div>
    </div>
</ng-template>
<ng-template #playable let-resource>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@playable">Playable: </span>
    <div fxLayout="row" fxLayoutAlign="start center" class="type-wrap">
        <div
            [class.disabled-playable]="(resource | resourcePlayableInfo).disabled"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="5px"
            class="registration-status-wrapper"
        >
            <div
                class="registration-status-circle"
                [style.border-color]="(resource | resourcePlayableInfo).borderColor"
                [style.background-color]="(resource | resourcePlayableInfo).backgroundColor"
                [style.cursor]="(resource | resourcePlayableInfo).disabled ? 'not-allowed' : 'pointer'"
                (click)="$event.stopPropagation()"
            ></div>
            <div fxLayout="column" fxLayoutAlign="start center">
                <div class="registration-status-label-text">{{ (resource | resourcePlayableInfo).label }}</div>
                <div *ngIf="(resource | resourcePlayableInfo).details" class="registration-status-label-details">
                    {{ (resource | resourcePlayableInfo).details }}
                </div>
            </div>
        </div>
        <div></div>
    </div>
</ng-template>

<ng-template #done_items let-resource>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@Progress">Progress: </span>
    <span *ngIf="ResourceTypes.parentType(resource.type_id) != ResourceTypes.MATERIAL">
        <div
            [ngClass]="{
                'grey-done': !resource.done_items,
                'darkblue-done': resource.done_items == resource.number_of_items
            }"
            class="progress-wrapper"
        >
            <span>{{ resource.done_items ? resource.done_items : '0' }}</span
            >/
            <span>{{ resource.number_of_items }}</span>
        </div>
    </span>
</ng-template>
<ng-template #examination let-resource>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@Certificate">Certificate: </span>
    <div
        *ngIf="resource | resourceCertificate as resCert"
        fxFlex.lt-md="grow"
        fxLayout="row"
        fxLayoutGap="3px"
        fxLayoutAlign="start center"
        class="pointer"
        [ngStyle]="{ color: resCert.color }"
        (click)="$event.stopPropagation(); download(resource)"
    >
        <mat-icon [ngClass]="{ 'disabled-icon': !resource.downloads }" class="cert-icon">
            {{ resCert.icon }}
        </mat-icon>
        {{ resCert.certificate }}
        <mat-icon class="download-icon" *ngIf="resource.downloads">save_alt</mat-icon>
    </div>
</ng-template>
<ng-template #tools let-resource>
    <div *ngIf="!(isMobile$ | async)" class="tools-cell-wrapper">
        <button
            *ngIf="canExpand(resource)"
            (click)="$event.stopPropagation(); expansionToggled(resource)"
            matTooltip="View"
            mat-icon-button
            i18n-matTooltip="@@view"
        >
            <mat-icon>{{ expandedFn(resource) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
    </div>
    <div class="w-100" fxLayout="row" fxLayoutAlign="space-between center" *ngIf="isMobile$ | async">
        <button
            class="hover-tools-btn view"
            mat-icon-button
            matTooltip="View"
            (click)="$event.stopPropagation(); browse(resource)"
            i18n-matTooltip="@@view"
        >
            <mat-icon>visibility</mat-icon>
        </button>
        <button
            class="hover-tools-btn view"
            mat-icon-button
            [matTooltip]="getPlayBtnTxt(resource)"
            (click)="$event.stopPropagation(); !resource.loading && play(resource)"
        >
            <mat-icon>play_circle</mat-icon>
        </button>
        <ng-container *ngIf="resource.last_publish">
            <button
                class="hover-tools-btn"
                *ngIf="!(shareLoading | async); else shareLoadTemp"
                mat-icon-button
                matTooltip="Share"
                i18n-matTooltip="@@share"
                (click)="$event.stopPropagation(); shareService.openShareDialog(resource, shareLoading)"
            >
                <mat-icon>share</mat-icon>
            </button>
        </ng-container>
        <button
            *ngIf="resource.downloads"
            class="hover-tools-btn"
            mat-icon-button
            matTooltip="Download PDF"
            i18n-matTooltip="@@downloadPDF"
            (click)="$event.stopPropagation(); download(resource)"
        >
            <mat-icon>save_alt</mat-icon>
        </button>

        <button
            *ngIf="!!resource.user_collaboration?.edit"
            (click)="$event.stopPropagation(); edit(resource)"
            mat-icon-button
        >
            <mat-icon>edit</mat-icon>
        </button>
        <button
            *ngIf="canExpand(resource)"
            (click)="$event.stopPropagation(); expansionToggled(resource)"
            mat-icon-button
        >
            <mat-icon>{{ expandedFn(resource) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
    </div>
</ng-template>
<ng-template #shareLoadTemp>
    <app-kd-logo-loading size="small"></app-kd-logo-loading>
</ng-template>
